<template>
  <v-container fluid mx-0 pa-0>
    <v-row style="max-width: 98%; margin: 0px auto">
      <div class="my-4" style="font-size: 1.2em">Liste des Budgets</div>
      <v-spacer />
      <v-text-field v-model="T_Search" append-icon="mdi-magnify" label="Rechercher" single-line hide-details class="mr-4"></v-text-field>
    </v-row>
    <v-data-table
      v-model="TO_Selected"
      :headers="TO_Headers"
      :items="TO_BudgetsList"
      :single-select="B_SingleSelect"
      :items-per-page="15"
      @click:row="Fct_HandleClick"
      :search="T_Search"
    >
      <template #item.search_ca="{ item }">
        <div>
          {{ item.libelle_CA }} <span style="color: #aaa">({{ item.cpteAnalytique }})</span>
        </div>
      </template>
      <template #item.search_na="{ item }">
        <div>
          {{ item.libelle_nature }} <span style="color: #aaa">({{ item.natureAnalytique }})</span>
        </div>
      </template>
      <template #item.montant_engage="{ item }">
        <div>
          {{ item.montant_engage | deuxDecimales }}
        </div>
      </template>
      <template #item.montant_consomme="{ item }">
        <div>
          {{ item.montant_consomme | deuxDecimales }}
        </div>
      </template>
      <template #item.montant_restant="{ item }">
        <div>
          {{ item.montant_restant | deuxDecimales }}
        </div>
      </template>
    </v-data-table>
    <v-row v-if="B_SuperAdmin" style="max-width: 98%; margin: 0px auto">
      <v-col lg="4">
        <div class="my-4">Envoi d'un fichier de données</div>
        <v-file-input v-model="O_File" label="Sélectionnez un fichier..." @change="Fct_HandleFileUpload"></v-file-input>
        <v-btn :disabled="!O_File" color="secondary" @click="Fct_SubmitFile">Envoyer un fichier</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { MixinBudgets } from "../../mixin/MixinBudgets";

export default {
  mixins: [MixinBudgets],
  name: "Budget",
  filters: {
    deuxDecimales(value) {
      return parseFloat(value).toFixed(2);
    }
  },
  data: () => ({
    B_SingleSelect: false,
    TO_Selected: [],
    TO_Headers: [
      { text: "Compte analytique", value: "search_ca", align: "left", sortable: false },
      { text: "Nature analytique", value: "search_na" },
      { text: "Période", value: "periode", align: "right" },
      { text: "Montant", value: "montant", align: "right" },
      { text: "Montant engagé", value: "montant_engage", align: "right" },
      { text: "Montant facturé", value: "montant_consomme", align: "right" },
      { text: "Montant restant", value: "montant_restant", align: "right" }
    ],
    TO_BudgetsList: [],
    O_File: null,
    T_Search: "",
    B_SuperAdmin: false
  }),
  created() {
    var T_SuperAdmin = this.$cookies.get("UserAdmin");
    this.B_SuperAdmin = T_SuperAdmin == "true";
  },
  mounted() {
    var T_CookiePeriod = this.$cookies.get("Period");
    var T_CookieAnalyticalAccountCode = this.$cookies.get("AnalyticalAccountCode");
    var L_UserID = this.$cookies.get("UserID");
    if (this.B_SuperAdmin) {
      if (T_CookieAnalyticalAccountCode == "" || T_CookieAnalyticalAccountCode == "all") {
        this.BudgetsLoadByYear(T_CookiePeriod);
      } else {
        this.BudgetsLoadByYearAndAACode(T_CookiePeriod, T_CookieAnalyticalAccountCode);
      }
    } else {
      if (T_CookieAnalyticalAccountCode == "" || T_CookieAnalyticalAccountCode == "all") {
        this.BudgetsLoadByYearAndUser(T_CookiePeriod, L_UserID);
      } else {
        this.BudgetsLoadByYearAndAACodeAndUser(T_CookiePeriod, T_CookieAnalyticalAccountCode, L_UserID);
      }
    }
  },
  methods: {
    Fct_HandleFileUpload() {
      /*this.file = this.$refs.file.files[0];*/
    },
    Fct_SubmitFile() {
      var T_Token = "JWT " + this.$cookies.get("BackEndToken");
      let O_FormData = new FormData();
      O_FormData.append("file", this.O_File);
      this.$BackEndAPI
        .post("importbudget/", O_FormData, { headers: { Authorization: T_Token } })
        .then(O_Response => {
          if (O_Response != null) {
            this.$root.$children[0].IsisInfo("Import effectué avec succès", "success");
            this.BudgetsReLoad();
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo(O_Error.response.data.Error, "error");
        });
    },
    Fct_HandleClick() {
      // Ajouter paramètre : O_Value
      // alert(JSON.stringify(O_Value));
    }
  }
};
</script>

<style scoped></style>
